<template>
  <v-container fluid grid-list-md>
    <div align="left" v-if=this.error>
      <v-alert :value="true" outline color="error" icon="warning">Network or System Issue since {{ unixtimeAt(this.refreshTime) }}. Please Try Again later. Last checked: {{ unixtimeAt(this.errorrefreshTime) }}</v-alert>
      <br>
    </div>    
    <div align="left" v-if=this.acknowledgeError>
      <v-alert :value="true" outline color="error" icon="warning">{{ this.acknowledgeError }}</v-alert>
      <br>
    </div>    
    <div align="left" v-else-if=this.showProgress>
      <v-alert :value="true" outline color="info" icon="priority_high">Refreshing</v-alert>
      <br>
    </div>
    <div align="left" v-else-if=this.has_alert>
      <v-alert :value="true" outline color="error" icon="warning">The last refreshed time of this screen is {{ unixtimeAt(this.refreshTime) }}, with {{ displayItemLength(items.length) }} Active Alerts not yet acknowledged.</v-alert>
      <br>
    </div>
    <div align="left" v-else>
      <v-alert :value="true" outline color="info" icon="info">No alert, the last refreshed time of this screen is {{ unixtimeAt(this.refreshTime) }}</v-alert>
      <br>
    </div>
    <v-data-iterator
      content-tag="v-layout"
      row
      wrap
      :items="items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
    >
      <v-flex
        slot="item"
        slot-scope="props"
        xs12
        sm6
        md4
        lg3
      >
        <v-card width="380px">
          <tbody>
            <tr>
              <th class="text-xs-left">{{ props.item.residentLabel }}<span style="color: red;">{{ props.item.resident }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">{{ props.item.unitLabel }}<span style="color: red;">{{ props.item.unitNum }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">{{ props.item.serialLabel }}<span style="color: red;">{{ props.item.deviceSerial }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">{{ props.item.contactNameLabel }}<span style="color: blue;">{{ props.item.contactName }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">{{ props.item.contactPhoneLabel }}<span style="color: blue;">{{ props.item.contactPhone }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">&nbsp;</th>
            </tr>
          </tbody>  
          <v-divider></v-divider>
          <tbody>
            <tr>
              <th class="text-xs-left">Alert Type</th>
              <th class="text-xs-center">Value</th>
              <th class="text-xs-right">Received At</th>
            </tr>
            <tr v-if=props.item.panicAlertTimestamp>
              <td class="text-xs-left" style="color: red;" width="22%">SOS/Panic</td>
              <td class="text-xs-center" style="color: red;" width="30%">{{ props.item.panicAlertValue }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.panicAlertTimestamp) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">SOS/Panic</td>
              <td class="text-xs-center" width="30%">{{ props.item.panicAlertValue }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.panicAlertTimestamp) }}</td>
            </tr>
             <tr v-if=props.item.fallAlertTimestamp>
              <td class="text-xs-left" style="color: red;" width="22%">Fall</td>
              <td class="text-xs-center" style="color: red;" width="30%">{{ props.item.fallAlertValue }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.fallAlertTimestamp) }}</td>
            </tr>
             <tr v-else>
              <td class="text-xs-left" width="22%">Fall</td>
              <td class="text-xs-center" width="30%">{{ props.item.fallAlertValue }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.fallAlertTimestamp) }}</td>
            </tr>
             <tr v-if=props.item.highHeartRateAlertTimestamp>
              <td class="text-xs-left" style="color: red;" width="22%">High H-Rate</td>
              <td class="text-xs-center" style="color: red;" width="30%">{{ props.item.highHeartRateAlertValue }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.highHeartRateAlertTimestamp) }}</td>
            </tr>
             <tr v-else>
              <td class="text-xs-left" width="22%">High H-Rate</td>
              <td class="text-xs-center" width="30%">{{ props.item.highHeartRateAlertValue }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.highHeartRateAlertTimestamp) }}</td>
            </tr>
             <tr v-if=props.item.lowHeartRateAlertTimestamp>
              <td class="text-xs-left" style="color: red;" width="22%">Low H-Rate</td>
              <td class="text-xs-center" style="color: red;" width="30%">{{ props.item.lowHeartRateAlertValue }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.lowHeartRateAlertTimestamp) }}</td>
            </tr>
             <tr v-else>
              <td class="text-xs-left" width="22%">Low H-Rate</td>
              <td class="text-xs-center" width="30%">{{ props.item.lowHeartRateAlertValue }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.lowHeartRateAlertTimestamp) }}</td>
            </tr>
          <v-divider></v-divider>
            <tr>
              <th class="text-xs-left" colspan="2">Notification Sent to</th>
              <th class="text-xs-right" width="48%">Sent At</th>
            </tr>
            <tr v-if=props.item.emailTimestamp>
              <td class="text-xs-left" style="color: red;" colspan="2">{{ props.item.emailTo }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.emailTimestamp) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" colspan="2">&nbsp;</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
             <tr v-if=props.item.SMSTimestamp>
              <td class="text-xs-left" style="color: red;" colspan="2">{{ props.item.SMSTo }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.SMSTimestamp) }}</td>
            </tr>
             <tr v-else>
              <td class="text-xs-left" colspan="2">&nbsp;</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
             <tr v-if=props.item.timeTimestamp>
              <td class="text-xs-left" style="color: red;" colspan="2">{{ props.item.timeTo }}</td>
              <td class="text-xs-right" style="color: red;" width="48%">{{ unixtimeAt(props.item.timeTimestamp) }}</td>
            </tr>
             <tr v-else>
              <td class="text-xs-left" colspan="2">&nbsp;</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
          </tbody>
          <v-divider></v-divider>
          <div>
            <v-dialog v-model="dialog" max-width="500" hide-overlay lazy>
              <v-btn color="primary" slot="activator" dark @click.native="
                deleteDeviceId = props.item.deviceId,
                deleteFirstName = props.item.careUserFirstName,
                deleteLastName = props.item.careUserLaststName,
                deleteserial = props.item.deviceSerial
                dialog = true">CLICK TO ACKNOWLEDGE ALERT</v-btn>
              <v-card>
                <v-card-text>
                  Click CONFIRM to acknowledge alert received from
                  <div class="red--text subheading">
                      {{ deleteFirstName }}
                      {{ deleteLastName }}
                  </div>watch {{ deleteserial }}
                </v-card-text>
                <v-spacer></v-spacer>
                <v-btn color="blue" @click.native="dialog = false" dark>CANCEL</v-btn>
                <v-btn color="red" @click.native="acknowledge()" dark>CONFIRM ACKNOWLEGE</v-btn>
              </v-card>
            </v-dialog>
          </div>
        </v-card>
      </v-flex>
    </v-data-iterator>
  </v-container>
</template>
<script>
  import mixins from '@/mixins.js'
  import DeviceService from '@/services/DeviceService'
  import DeviceAlertService from '@/services/DeviceAlertService'
  import DevicePanicService from '@/services/DevicePanicService'
  import CareUserService from '@/services/CareUserService'
  import moment from 'moment'

  export default {
    data(){
      return {
        rowsPerPageItems: [4, 8, {"text": "All", "value": -1}],
        pagination:{
          rowsPerPage: -1
        },
        items: [],
        timer: '',
        refreshTime: '',
        errorrefreshTime: '',
        has_alert: false,
        deleteDeviceId: '',
        deleteFirstName: '',
        deleteLastName: '',
        deleteserial: '',
        dialog: false,
        error: '',
        acknowledgeError: '',
      }
    },
    mixins: [mixins],
    created: function() {
      this.fetchAlerts();
      this.timer = setInterval(this.fetchAlerts, 15000)
    },
    methods: {
      async fetchAlerts() {
        try {
          this.dialog = false
          this.error = ''
          this.showProgress = true
          this.has_alert = false
          var devices = (await DeviceService.index()).data
          if (devices) {
            var new_items = []
            for (var i = 0; i < devices.length; i++) {
              var b_alert = false
              var panic_alert_value = 200
              var low_heart_rate_alert_value = 200
              var high_heart_rate_alert_value = 200
              var fall_alert_value = 200
              var email_to = null
              var sms_to = null
              var time_to = null
              var panic_alert_timestamp = null
              var low_heart_rate_alert_timestamp = null
              var high_heart_rate_alert_timestamp = null
              var fall_alert_timestamp = null
              var email_to_timestamp = null
              var sms_to_timestamp = null
              var time_to_timestamp = null
              var devicealertlowheartrate = (await DeviceAlertService.show({deviceId: devices[i].deviceId,latest: true,alertType: 9021})).data
              if (devicealertlowheartrate) {
                if (devicealertlowheartrate[0]) {
                  b_alert = true
                  if (devicealertlowheartrate[0].alertValue) {
                    low_heart_rate_alert_value = devicealertlowheartrate[0].alertValue
                  }
                  low_heart_rate_alert_timestamp = devicealertlowheartrate[0].deviceTimestamp
                  if (devicealertlowheartrate[0].sentEmailTo) {
                    email_to = devicealertlowheartrate[0].sentEmailTo
                    email_to_timestamp = devicealertlowheartrate[0].sentEmailAt
                  }
                  if (devicealertlowheartrate[0].sentSMSTo) {
                    sms_to = devicealertlowheartrate[0].sentSMSTo
                    sms_to_timestamp = devicealertlowheartrate[0].sentSMSAt
                  }
                } else {
                  low_heart_rate_alert_value = '(No Alert)'
                }
              }
              var devicealerthighheartrate = (await DeviceAlertService.show({deviceId: devices[i].deviceId,latest: true,alertType: 9022})).data
              if (devicealerthighheartrate) {
                if (devicealerthighheartrate[0]) {
                  b_alert = true
                  if (devicealerthighheartrate[0].alertValue) {
                    high_heart_rate_alert_value = devicealerthighheartrate[0].alertValue
                  }
                  high_heart_rate_alert_timestamp = devicealerthighheartrate[0].deviceTimestamp
                  if (devicealerthighheartrate[0].sentEmailTo) {
                    email_to = devicealerthighheartrate[0].sentEmailTo
                    email_to_timestamp = devicealerthighheartrate[0].sentEmailAt
                  }
                  if (devicealerthighheartrate[0].sentSMSTo) {
                    sms_to = devicealerthighheartrate[0].sentSMSTo
                    sms_to_timestamp = devicealerthighheartrate[0].sentSMSAt
                  }
                } else {
                  high_heart_rate_alert_value = '(No Alert)'
                }
              }
              var devicealerfall = (await DeviceAlertService.show({deviceId: devices[i].deviceId,latest: true,alertType: 9039})).data
              if (devicealerfall) {
                if (devicealerfall[0]) {
                  b_alert = true
                  if (devicealerfall[0].alertValue) {
                    fall_alert_value = 'DETECTED'
                  }
                  fall_alert_timestamp = devicealerfall[0].deviceTimestamp
                  if (devicealerfall[0].sentEmailTo) {
                    email_to = devicealerfall[0].sentEmailTo
                    email_to_timestamp = devicealerfall[0].sentEmailAt
                  }
                  if (devicealerfall[0].sentSMSTo) {
                    sms_to = devicealerfall[0].sentSMSTo
                    sms_to_timestamp = devicealerfall[0].sentSMSAt
                  }
                } else {
                  fall_alert_value = '(No Alert)'
                }
              }
              var devicealertpanic = (await DeviceAlertService.show({deviceId: devices[i].deviceId,latest: true,alertType: 9011})).data
              if (devicealertpanic) {
                if (devicealertpanic[0]) {
                  b_alert = true
                  if (devicealertpanic[0].alertValue) {
                    panic_alert_value = devicealertpanic[0].alertValue
                  }
                  panic_alert_timestamp = devicealertpanic[0].deviceTimestamp
                  if (devicealertpanic[0].sentEmailTo) {
                    email_to = devicealertpanic[0].sentEmailTo
                    email_to_timestamp = devicealertpanic[0].sentEmailAt
                  }
                  if (devicealertpanic[0].sentSMSTo) {
                    sms_to = devicealertpanic[0].sentSMSTo
                    sms_to_timestamp = devicealertpanic[0].sentSMSAt
                  }
                } else {
                  panic_alert_value = '(No Alert)'
                }
              }
              if (b_alert) {
                var careUserId = devices[i].careUserId
                var careuser = (await CareUserService.show({careUserId})).data
                var first_name = ''
                var last_name = ''
                var unit_num = ''
                var contact_first_name = ''
                var contact_last_name = ''
                var contact_phone = ''
                if (careuser) {
                  first_name = careuser.firstName
                  last_name = careuser.lastName
                  if (careuser.address) {
                    unit_num = careuser.address.unitNumber
                  }
                  if (careuser.Emergency1) {
                    contact_first_name = careuser.Emergency1.firstName
                    contact_last_name = careuser.Emergency1.lastName
                    if (careuser.Emergency1.phone) {
                      contact_phone = careuser.Emergency1.phone.phone
                    }
                  }
                }
                var item = {
                  deviceId: devices[i].deviceId,
                  serialLabel: 'Device Serial: ',
                  deviceSerial: devices[i].serial,
                  careUserFirstName: first_name,
                  careUserLaststName: last_name,
                  residentLabel: 'Resident Name: ',
                  resident:  first_name + ' ' + last_name,
                  unitLabel: 'Unit: ',
                  unitNum: unit_num,
                  contactNameLabel: 'Emergency Contact: ',
                  contactName: contact_first_name + ' ' +  contact_last_name,
                  contactPhoneLabel: 'Emergency Contact Phone: ',
                  contactPhone: contact_phone,
                  panicAlertValue: panic_alert_value,
                  panicAlertTimestamp: panic_alert_timestamp,
                  lowHeartRateAlertValue: low_heart_rate_alert_value,
                  lowHeartRateAlertTimestamp: low_heart_rate_alert_timestamp,
                  highHeartRateAlertValue: high_heart_rate_alert_value,
                  highHeartRateAlertTimestamp: high_heart_rate_alert_timestamp,
                  fallAlertValue: fall_alert_value,
                  fallAlertTimestamp: fall_alert_timestamp,
                  emailTo: email_to,
                  emailTimestamp: email_to_timestamp,
                  SMSTo: sms_to,
                  SMSTimestamp: sms_to_timestamp,
                  timeTo: time_to,
                  timeTimestamp: time_to_timestamp
                }
                new_items.push(item)
                this.has_alert = b_alert
              }
            }
            this.items = []
            this.items = new_items
          } else {
            this.has_alert = false
          }
          this.showProgress = false
          this.refreshTime = Date.now()
        } catch (error) {
          this.showProgress = false
          this.error = this.handleError(error)
          this.items = []
          this.errorrefreshTime = Date.now()
        }
      },
      async acknowledge() {
        this.error = ''
        this.acknowledgeError = ''
        try {
          this.dialog = false
          const response = await DeviceAlertService.state({
            deviceId: this.deleteDeviceId,
            state: 1
          })
        } catch (error) {
          this.showProgress = false
          this.acknowledgeError = this.handleError(error)
        }
        try {
          this.fetchAlerts()
        } catch (error) {
          this.showProgress = false
          this.error = this.handleError(error)
        }
      },
      unixtimeAt: function(time) {
        if(time) {
          return moment(time).format("YYYY-MM-DD HH:mm:ss A")
        }
        else {
          return null
        }
      },
      displayItemLength: function(length) {
        if (length) {
          if (length >=1 ) {
            var audio = new Audio( '/static/beep_01a.mp3')
            audio.play()
          }
        }
        return length
      },
      cancelAutoUpdate: function() { clearInterval(this.timer) }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Alert.vue